import script from "./SlideView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlideView.vue?vue&type=script&setup=true&lang=ts"

import "./SlideView.vue?vue&type=style&index=0&id=b5fa75dc&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5fa75dc"]])

export default __exports__